import { render, staticRenderFns } from "./LgFormInputNumber.vue?vue&type=template&id=36950823&scoped=true"
import script from "./LgFormInputNumber.vue?vue&type=script&lang=js"
export * from "./LgFormInputNumber.vue?vue&type=script&lang=js"
import style0 from "./LgFormInputNumber.vue?vue&type=style&index=0&id=36950823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36950823",
  null
  
)

export default component.exports